import axios from 'axios';

const baseURL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Normalise FastAPI 422 detail arrays into a readable string
export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || 'Something went wrong. Please try again.';
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(' • ');
  if (typeof d?.msg === 'string') return d.msg;
  return String(d);
}

export default api;
